import roleAliado from './roleAliado/roleAliado';
import roleExecutive from './roleExecutive/roleExecutive';
import roleDisbursement from './roleDisbursement/roleDisbursement';
import rolePortfolioAssistant from './rolePortfolioAssistant/rolePortfolioAssistant';
import rolePortfolio from './rolePortfolio/rolePortfolio';
import roleMesaDeAprobacion from './roleMesaDeAprobacion/roleMesaDeAprobacion';
import roleAprobador from './roleAprobador/roleAprobador';
import roleCreditCoordinator from './roleCreditCoordinator/roleCreditCoordinator';
import roleMesaDeAyuda from './roleMesaDeAyuda/roleMesaDeAyuda';
import roleComercial from './roleComercial/roleComercial';
import roleContabilidad from './roleContabilidad/roleContabilidad';
import roleHelpDeskCoordinator from './roleHelpDeskCoordinator/roleHelpDeskCoordinator';
import roleRiskDirector from './roleRiskDirector/roleRiskDirector';
import roleAudit from './roleAudit/roleAudit';
import roleSocialDevelop from './roleSocialDevelop/roleSocialDevelop';
import roleSalesRoomManager from './roleSalesRoomManager/roleSalesRoomManager';
import roleOriginatingExecutive from './roleOriginatingExecutive/roleOriginatingExecutive';
import roleRegionalDirector from './roleRegionalDirector/roleRegionalDirector';
import roleZoneDirector from './roleZoneDirector/roleZoneDirector';
import roleManagement from './roleManagement/roleManagement';
import roleArchive from './roleArchive/roleArchive';
import roleDigitalAlly from './roleDigitalAlly/roleDigitalAlly';
import roleSupervisor from './roleSupervisor/roleSupervisor';
import roleHumanManagement from './roleHumanManagement/roleHumanManagement';
import roleOperaciones from './roleOperaciones/roleOperaciones';
import roleSeguro from './roleSeguros/roleSeguro';
import roleFinancialManager from './roleFinancialManager/roleFinanacialManager';
import roleOperationsManager from './roleOperationsManager/roleOperationsManager';
import roleMarket from './roleMarket/roleMarket';
import roleAdministrativeDirector from './roleAdministrativeDirector/roleAdministrativeDirector';
import roleLegalAsesor from './roleLegalAsesor/roleLegalAsesor';
import roleFinancialAnalyst from './roleFinancialAnalyst/roleFinancialAnalyst';
import roleSupport from './roleSupport/roleSupport';
import roleManagingAlly from './roleManagingAlly/roleManagingAlly';
import roleSalesManager from './roleSalesManager/roleSalesManager';

export default Object.assign(
    {},
    roleAliado,
    roleExecutive,
    roleDisbursement,
    rolePortfolioAssistant,
    roleAprobador,
    roleMesaDeAprobacion,
    roleCreditCoordinator,
    roleMesaDeAyuda,
    roleComercial,
    roleContabilidad,
    roleHelpDeskCoordinator,
    roleRiskDirector,
    roleAudit,
    roleSocialDevelop,
    roleSalesRoomManager,
    rolePortfolio,
    roleOriginatingExecutive,
    roleRegionalDirector,
    roleZoneDirector,
    roleManagement,
    roleArchive,
    roleDigitalAlly,
    roleSupervisor,
    roleHumanManagement,
    roleOperaciones,
    roleSeguro,
    roleFinancialManager,
    roleOperationsManager,
    roleMarket,
    roleAdministrativeDirector,
    roleLegalAsesor,
    roleFinancialAnalyst,
    roleSupport,
    roleManagingAlly,
    roleSalesManager
);
